document.addEventListener("DOMContentLoaded", async ()=>{
    const PATH = {
        URL: "https://api-v2.fix-tab.com",
        END_POINT: "/product/v1.1/qr-code/public"
    };
    try {
        const path = window.location.pathname.split("/");
        const code = path.pop();
        const preFix = path.pop();
        if ([
            "qr",
            "verify"
        ].indexOf(preFix) === -1) return;
        const response = await fetch(`${PATH.URL}${PATH.END_POINT}/${code}`);
        const result = await response.json();
        document.querySelector("[data-id='product-name']").textContent = result.data?.product?.sku?.name;
        document.querySelector("[data-id='fda-number']").textContent = result.data?.product?.sku?.detail;
        document.querySelector("[data-id='serial-number']").textContent = result.data?.product?.serialNumber;
        document.querySelector("[data-id='clinic']").textContent = result.data?.product?.branch?.company?.name;
        if (result.data?.product?.branch?.name?.trim().toLowerCase() !== result.data?.product?.branch?.company?.name?.trim().toLowerCase()) document.querySelector("[data-id='clinic-branch']").textContent = result.data?.product?.branch?.name;
    } catch (error) {
        console.error("Error fetching data:", error);
        alert("Invalid QR code data. Please try again.");
    }
    document.querySelector("#more-info-button").addEventListener("click", ()=>{
        window.open("https://www.wontech-asia.com/page/clinic/", "_blank");
    });
});

//# sourceMappingURL=index.28c532ac.js.map
